<ion-app>
    <ion-split-pane contentId="main-content" [class.local]="IsLocal"
        [ngClass]="IsProduction ? 'production': 'development'">

        <ion-menu class="sidemenu" menuId="main-menu" contentId="main-content" type="overlay">
            <side-menu style="height: 100%;"></side-menu>
        </ion-menu>

        <ion-router-outlet id="main-content"></ion-router-outlet>

    </ion-split-pane>
</ion-app>